import { render, staticRenderFns } from "./Tema4_4-1.vue?vue&type=template&id=17a73300&"
import script from "./Tema4_4-1.vue?vue&type=script&lang=js&"
export * from "./Tema4_4-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports